import { gql } from '@apollo/client'

export default gql(`
query checkUserAccess( $user: String! $project: String $isFirstSignIn: Boolean $userAgent: String) {
        checkUserAccess(
            user: $user
            project: $project
            isFirstSignIn: $isFirstSignIn
            userAgent: $userAgent
        ) {
            mfaStatus
            projectAccess
        }
    }`
)
